/**
 * @description
 */

import Api from '../../path';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';

interface IInput {
    feed_id: string;
    page: number;
    size: number;
}

interface ILikeUserInfo extends IUserInfo {
    like_time: number;
}

export interface IOutput extends IList<ILikeUserInfo> {
    // has_like: number;
}

export const getUserLikeList = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.USER_LIKE_LIST, data).then((res: IResponse<IOutput>) => {
        return res;
    });
};

export const getUserLikeListSync = fetchDataSync(getUserLikeList);
